import { Status } from '../models/status.interfaces';

export const PlatinumMedallionBannerStatusMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'PLATINUM MEDALLION®',
    level: '0',
    name: 'platinum'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const PlatinumMedallionBannerStatusWithLifetimeMocks: Status = {
  priority: {
    label: '',
    url: '',
    active: false
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: 'platinum'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const PlatinumMedallionBannerWithSkyPriorityStatusMocks: Status = {
  priority: {
    label: 'SKY PRIORITY',
    url: '/us/en/check-in-security/sky-priority',
    active: true
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'PLATINUM MEDALLION®',
    level: '1',
    name: 'platinum'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const PlatinumMedallionBannerWithSkyPriorityWithLifetimeStatusMocks: Status =
  {
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority',
      active: true
    },
    tier: {
      title: '',
      subtitle: '',
      level: '1',
      name: 'platinum'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };
